import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import '@/css/common.scss';
import Toast from '@/components/Toast';
import Loading from '@/components/Loading';
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.use(Toast);
Vue.use(Loading);
export default Vue;